module.exports = __webpack_public_path__ + "public/images/money-skills.f65c6de33aa93e5e9bf476ff64b4a10c.jpg";